const items = state => state.items.data
const error = state => state.error
const isLoading = state => state.isLoading
const forms = state => state.forms
const dataTemp = state => state.dataTemp

const totalPrice = state => state.totalPrice.data
const errorTotalPrice = state => state.errorTotalPrice
const isLoadingTotalPrice = state => state.isLoadingTotalPrice

export default {
  isLoading,
  items,
  error,
  forms,
  dataTemp,

  totalPrice,
  errorTotalPrice,
  isLoadingTotalPrice
}



// WEBPACK FOOTER //
// ./src/store/modules/book/getters.js